"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverPasswordForm = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Button_1 = require("../../Button");
const Field_1 = require("../../Form/Field");
const ValidationErrors_1 = require("../../ValidationErrors");
const customErrorsMap_1 = __importDefault(require("./customErrorsMap"));
require("./index.scss");
const className = 'recover-password-form';
class RecoverPasswordForm extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            formData: this.props.formData,
            focusFieldName: this.props.focusFieldName,
        };
        this.handleFieldChange = (fieldName, event) => {
            const { value } = event.target;
            const updatedData = {
                ...this.state.formData,
                ...{
                    [fieldName]: value,
                },
            };
            this.props.onChange({
                fieldName,
                formData: updatedData,
            });
            this.setState({
                formData: updatedData,
                focusFieldName: fieldName,
            });
        };
        this.handleSubmit = (event) => {
            event.preventDefault();
            this.props.onSubmit(this.state.formData);
        };
        this.setFocus = () => {
            var _a, _b;
            if (this.state.focusFieldName !== undefined) {
                (_b = (_a = this.fieldRefs[this.state.focusFieldName].current).focus) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        };
        this.getFormError = (fieldName) => {
            var _a;
            const customMapIfExists = (_a = customErrorsMap_1.default[fieldName]) !== null && _a !== void 0 ? _a : {};
            return (0, ValidationErrors_1.getFormError)(this.props.formErrors, fieldName, customMapIfExists);
        };
        this.fieldRefs = {
            email: react_1.default.createRef(),
        };
    }
    componentDidMount() {
        this.setFocus();
    }
    componentDidUpdate() {
        this.setFocus();
    }
    render() {
        const classNames = (0, classFunctions_1.getClassNames)(className, this.props.modificators);
        const { formData } = this.state;
        const { isSubmitButtonDisabled, } = this.props;
        return (react_1.default.createElement("form", { className: classNames, onSubmit: this.handleSubmit },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("h3", { className: `${className}__title` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/RecoverPasswordForm/Title:text', defaultMessage: 'Reset password' })),
                react_1.default.createElement("p", null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/RecoverPasswordForm/Instruction:text', defaultMessage: 'Please enter your email address. You will receive a recovery link shortly.' })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { autoComplete: 'off', type: 'text', ref: this.fieldRefs.email, value: formData.email, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/RecoverPasswordForm/Email:label', defaultMessage: 'E-mail' }), error: this.getFormError('email'), onChange: event => this.handleFieldChange('email', event) })),
                react_1.default.createElement("div", { className: `${className}__buttons` },
                    react_1.default.createElement(Button_1.Button, { type: 'submit', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/RecoverPasswordForm/Submit:label', defaultMessage: 'Send' }), disabled: isSubmitButtonDisabled })))));
    }
}
exports.RecoverPasswordForm = RecoverPasswordForm;
RecoverPasswordForm.defaultProps = {
    formData: {
        email: '',
    },
    formErrors: {},
    isSubmitButtonDisabled: false,
    focusFieldName: undefined,
    onChange: () => {
    },
    onSubmit: () => {
    },
};
//# sourceMappingURL=index.js.map